import {FLOOD_THRESHOLD_FOLDER, URL_ROOT_FLE, URL_FLOOD_JSON} from "../constants/constants";

export function getCountryDataJsonUrl(country) {
  return `${URL_ROOT_FLE}/data/${country}/${FLOOD_THRESHOLD_FOLDER}${country}.json`;
}

export function getCountryStochasticDataJsonUrl(country, dataType) {
    return `${URL_ROOT_FLE}/data/stochastic/${country}/${dataType}.json`;
    //return `${URL_FLOOD_JSON}${country}/${dataType}.json`;
}

export function getMapUrl(tiffFileName, transparent = true, format = 'png', width = 512, height = 512) {
  const baseUrl = 'https://ff.arc.int/geoserver/wms';
  const layerName = `flood_foresight:${tiffFileName.replace(/\.[^/.]+$/, '')}`;
  const bbox = '{bbox-epsg-3857}';

  const url = `${baseUrl}?service=WMS&version=1.1.0&request=GetMap&layers=${layerName}&bbox=${bbox}&transparent=${transparent}&width=${width}&height=${height}&srs=EPSG:3857&styles=&format=image/${format}`;

  return url;
}
